import { z } from "zod";
// COORDINATION REQUIRED: LC-96 must coordinate before editing this narrow shared
// layout evidence contract. Product layout policy remains in Comic/Recipe files.
const sha256Schema = z.string().regex(/^[a-f0-9]{64}$/);
export const normalizedLayoutBoxV1Schema = z
    .object({
    x: z.number().min(0).max(1),
    y: z.number().min(0).max(1),
    width: z.number().positive().max(1),
    height: z.number().positive().max(1),
})
    .strict()
    .superRefine((box, context) => {
    if (box.x + box.width > 1)
        context.addIssue({
            code: "custom",
            path: ["width"],
            message: "The normalized box must remain inside the page width.",
        });
    if (box.y + box.height > 1)
        context.addIssue({
            code: "custom",
            path: ["height"],
            message: "The normalized box must remain inside the page height.",
        });
});
export const layoutPreflightIssueV1Schema = z
    .object({
    code: z.string().min(1).max(100),
    severity: z.enum(["WARNING", "BLOCKING"]),
    path: z.string().min(1).max(500),
    message: z.string().min(1).max(1_000),
})
    .strict();
export const layoutPreflightResultV1Schema = z
    .object({
    version: z.literal(1),
    product: z.enum(["COMIC", "RECIPE"]),
    passed: z.boolean(),
    contentComplete: z.boolean(),
    sourceTextHashSha256: sha256Schema,
    renderedTextHashSha256: sha256Schema,
    sourceTextItemCount: z.number().int().nonnegative(),
    renderedTextItemCount: z.number().int().nonnegative(),
    minimumRenderedTextPoints: z.number().nonnegative(),
    issues: z.array(layoutPreflightIssueV1Schema).max(1_000),
})
    .strict()
    .superRefine((result, context) => {
    const blockers = result.issues.some(({ severity }) => severity === "BLOCKING");
    if (result.passed !== (!blockers && result.contentComplete))
        context.addIssue({
            code: "custom",
            path: ["passed"],
            message: "Layout pass state must reflect content completeness and blocking findings.",
        });
    if (result.contentComplete !==
        (result.sourceTextHashSha256 === result.renderedTextHashSha256 &&
            result.sourceTextItemCount === result.renderedTextItemCount))
        context.addIssue({
            code: "custom",
            path: ["contentComplete"],
            message: "Content completeness must be derived from ordered text hashes and item counts.",
        });
});
//# sourceMappingURL=book-layout.js.map